module.exports = __webpack_public_path__ + "assets/ac65485a3a2afd6f9fffcd39e5bb9c06.svg";